import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalService } from '../services/local.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const localService = inject(LocalService);
  const userData = localService.getData('son_user');
  const token = userData?.authToken;

  const clone = req.clone({
    ...(token
      ? {
          headers: req.headers.set('Authorization', `Bearer ${token}`),
        }
      : {}),
  });
  return next(clone);
};
